import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import ActionButtons from "../../components/action_buttons";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { axiosApi } from "../../../services/axios_api";
import { Dropdown } from "primereact/dropdown";

const AssignUser = ({ rowData ,onHide,editable,  setRes,setShowDialog}) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    console.log('rowData', rowData)

    useEffect(() => {
        const fetchUsers = async () => {
            setLoading(true);
            try {
                
                const response = await axiosApi.get(
                    `/Portal/lists/users`
                );
                setUsers(response.data.body);
            } catch (error) {
                toast.error("Failed to fetch roles data.");
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);
    const validationSchema = Yup.object({

        assignedTo: Yup.string().required("Please select Description."),
        description: Yup.string().required("password is Description."),

    });

    // console.log(rowData);

    const formik = useFormik({
        initialValues: {
            assignedTo: rowData?.assignedTo || "",
            description: rowData?.description || "",

        },

        validationSchema,
        onSubmit: async (data) => {
            setLoading(true);
            try {
                let response;
                data.id = rowData?.id; 
                if (editable) {
                    data.id = rowData.id;
                    response = await axiosApi.put("/Portal/users/edit", data);
                } else {
                    response = await axiosApi.put("/Portal/csr/set-assigned-to", data);
                }
            
                console.log("API Response:", response.data);
            
                if (response.data.responseCode === "200") {
                    toast.success(response.data?.responseDescription || "Operation Successful!");
                } else {
                    toast.error(
                        response.data?.responseDescription || "Something went wrong!"
                    );
                }
                setRes(response);
                setShowDialog(false);
            } catch (error) {
                // Only show error if an actual exception occurs
                console.error("API Error:", error);
                toast.error(
                    error.response?.data?.message || 
                    "An unexpected error occurred. Please try again."
                );
            } finally {
                setLoading(false);
            }
            
        }
    
    });

    return (
        <div className="main-form">
            <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="companyName">
                            Assign User <span className="text-danger"> *</span>
                        </label>
                        <Dropdown
                            filter
                            id="assignedTo"
                            name="assignedTo"
                            value={formik.values.assignedTo}
                            onChange={formik.handleChange}
                            options={users.map((users) => ({
                                label: users.name,
                                value: users.id,
                            }))}
                            placeholder="Select User"
                        />
                        {formik.touched.assignedTo && formik.errors.assignedTo && (
                            <small className="p-error">{formik.errors.assignedTo}</small>
                        )}
                    </div>
                  
                  
                    <div className="field col-12 md:col-6">
                        <label htmlFor="feeName">
                            Description <span className="text-danger"> *</span>
                        </label>
                        <InputText
                            //   keyfilter={/^[a-zA-Z\s]*$/}
                            placeholder="Enter Description"
                            maxLength={"20"}
                            id="description"
                            name="description"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                        />
                        {formik.touched.description && formik.errors.description && (
                            <small className="p-error">{formik.errors.description}</small>
                        )}
                    </div>

                </div>

                <div className="form-buttons mt-4">
                    <ActionButtons
                        loading={loading}
                        onCancel={onHide}
                        onSave={formik.handleSubmit}
                        saveLabel={"Save Changes"}
                        showSave={true}
                        cancelLabel="Cancel"
                    />
                </div>
            </form>
        </div>
    )
}

export default AssignUser